import api from "./api";
import { config } from "./config.service";

const API_URL = config.host_api;

export const getGrantees = (mentor_id) => {
  return api
    .get(API_URL + `grantees/${mentor_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};


export const getGranteesAdmin = () => {
  return api
    .get(API_URL + `grantees/admin`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

